import { useEffect, useState, useRef } from "react";
import {
  Card,
  Typography,
  Grid,
  Input,
  Button,
  Link,
  Select,
  // FileInputField,
  InputAdornment,
  Alert,
  MenuItem,
} from "@mui/material";

import { FileInput } from "@deere/fuel-react/FileInput";
import {FileList} from '@deere/fuel-react/FileList';
import {FileListItem} from '@deere/fuel-react/FileListItem';
import {FileValidationList} from '@deere/fuel-react/FileValidationList';
import {FileValidationListItem} from '@deere/fuel-react/FileValidationListItem';
// import { InfoOutlined, CalendarToday } from "@material-ui/icons";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { IconButton } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { useAs2Client, useClient } from "../hooks/useClient";
import {
  setCaCertificateData,
  setTrustedCertificateData,
  setAs2PartnerData,
  setUpdateMailData,
} from "../utils/postJsons";
import SubmitAs2 from "../utils/modal-as2-confirmation";

export const UpdateAs2RelationShip = (props) => {
  const { userEmail } = props;
  const [tradingPartnersList, setTradingPartnersList] = useState([]);
  const [adapterFlag, setAdapterFlag] = useState(false);
  const [connection, setConnection] = useState("");
  const [as2Id, setAs2Id] = useState(null);
  const [profileName, setProfileName] = useState("");
  const [ipAdress, setIpAdress] = useState("");
  const [encryptionAlgo, setEncryptionAlgo] = useState("0");
  const [signingAlgo, setSigningAlgo] = useState("5");
  const [successSubmit, setSuccessSubbmit] = useState(false);
  const [newCaCertificateText, setNewCaCertificateText] = useState("");
  const [newExchangeCertificateText, setNewExchangeCertificateText] = useState("");
  const [newCaCertificateName, setNewCaCertificateName] = useState("");
  const [newExchangeCertificateName, setNewExchangeCertificateName] = useState("");
  const [currentCaCertificateName, setCurrentCaCertificateName] = useState("");
  const [currentExchangeCertificateName, setCurrentExchangeCertificateName] = useState("");
  const [certsExpDate, setCertsExpDate] = useState({});
  const [caCertUpdate, setCaCertUpdate] = useState(false);
  const [exchangeCertUpdate, setExchangeCertUpdate] = useState(false);
  const [, setCaCertificateName] = useState("");
  const [, setExchangeCertificateName] = useState("");
  const [, setIsSearched] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [certAlert, setCerAlert] = useState(false);
  const [emptyFieldAlert, setEmptyFieldAlert] = useState(false);
  const [as2TpVerification, setAs2TpVerification] = useState({});
  const [invalidCAFileType, setInvalidCAFileType] = useState();
  const [invalidExSignFileType, setInvalidExSignFileType] = useState();
  const { oktaAuth } = useOktaAuth();
  const client = useClient(oktaAuth.getAccessToken());
  const as2Client = useAs2Client(oktaAuth.getAccessToken());
  const caCerRef = useRef();
  const exSignCerRef = useRef();
  const validateCACert = (file, cerType) => {
  const isValidExtension = file.name.endsWith('.cer') || file.name.endsWith('.der') ;
  

    setInvalidCAFileType(!isValidExtension);


    if (isValidExtension) {
        extractFile(file, cerType);
        certName(cerType);
    } 
};
  const validateExSignCert = (file, cerType) => {
    const isValidExtension = file.name.endsWith('.cer') || file.name.endsWith('.der') ;
  

    setInvalidExSignFileType(!isValidExtension);


    if (isValidExtension) {
        extractFile(file, cerType);
        certName(cerType);
    } 
};
  const certName = (type) => {
    if (ipAdress.length > 1) {
      let certName = ipAdress.split("/");
      certName = certName[2].split(":")[0];
      certName = `${certName}_${type}`;

      //console.log(certName)

      switch (type) {
        case "trusted":
          setExchangeCertificateName(certName);
          setEmptyFieldAlert(false);
          break;
        case "CA":
          setCaCertificateName(certName);
          setEmptyFieldAlert(false);
          break;
      }
    } else {
      setEmptyFieldAlert(true);
    }
  };
  useEffect(() => {
    const fetchCodeListData = async () => {
      try {
        const response = await as2Client.get(
          "api/code-list/list?list-name=JD_SupplierAS2IDReference"
        );
        const data = response.data.map((tp) => {
          return {
            supp: tp.receiverItem,
            code: tp.senderItem,
          };
        });
        const cleanData = [];
        const unique = data.filter((element) => {
          const isDuplicate = cleanData.includes(element.code);
          if (!isDuplicate) {
            cleanData.push(element.code);
            return true;
          }
          return false;
        });
        setTradingPartnersList(unique);
        return response.status;
      } catch (error) {
        return 400;
      }
    };

    fetchCodeListData();
    const data = window.localStorage.getItem("HTTP_CLIENT_ADAPTER");
    if (data != null) setAdapterFlag(JSON.parse(data));
  }, []);

  useEffect(() => {
    if (tradingPartnersList.length > 0)
      setConnection(tradingPartnersList.at(0).code);
  }, [tradingPartnersList]);

  useEffect(() => {
    window.localStorage.setItem(
      "HTTP_CLIENT_ADAPTER",
      JSON.stringify(adapterFlag)
    );
  }, [adapterFlag]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [showAlert, certAlert, emptyFieldAlert]);

  useEffect(() => {
    checkFields();
  }, [profileName, ipAdress]);

  const displayInfoAlert = () => {
    setShowAlert((current) => !current);
  };

  const downnloadIpRanges = async () => {
    if (process.env.REACT_APP_ENV_CONNECTION_INFO === "DEVL_CONNECTION_INFO") {
      try {
        const element = document.createElement("a");
        const devlConnectionInfo = await import(
          "../../../assets/zip/DEVL_CONNECTION_INFO.zip"
        );
        element.href = devlConnectionInfo.default;
        element.download = "DEVL_CONNECTION_INFO.zip";
        document.body.appendChild(element);
        element.click();
      } catch (error) {
        console.log("error");
      }
    } else if (
      process.env.REACT_APP_ENV_CONNECTION_INFO === "PROD_CONNECTION_INFO"
    ) {
      try {
        const element = document.createElement("a");
        const devlConnectionInfo = await import(
          "../../../assets/zip/PROD_CONNECTION_INFO.zip"
        );
        element.href = devlConnectionInfo.default;
        element.download = "PROD_CONNECTION_INFO.zip";
        document.body.appendChild(element);
        element.click();
      } catch (error) {
        console.log("error");
      }
    }
  };

  const getAs2ConnectionInfo = async () => {
    try {
      const response = await client.get(
        `B2BAPIs/svc/as2tradingpartners/?_range=0-999&as2Identifier=${connection}`
      );
      let certsExpDate = {};
      response.data.map((tp) => {
        if (tp.as2Identifier === connection) {
          const id = decodeURIComponent(tp._id);
          setAs2Id(id);
          console.log(id);
          setProfileName(tp.profileName);
          setIpAdress(tp.endPoint);
          setEncryptionAlgo(tp.encryptionAlgorithm.code);
          setSigningAlgo(tp.signingAlgorithm.code);
          setCurrentCaCertificateName(tp.caCertificate[0].certName);
          setCurrentExchangeCertificateName(tp.exchangeCertificate[0].certName);

          certsExpDate = {
            caExpDate: tp.caCertificate[0].notAfterDate,
            trustedExpDate: tp.exchangeCertificate[0].notAfterDate,
          };
        }
      });
      if (response.status === 200 || response.status === 201) {
        console.log(certsExpDate);
        return certsExpDate;
      }
      return response.status;
    } catch (error) {
      return 400;
    }
  };

  const isCertificateDuplicated = async (type, name) => {
    try {
      const response = await client.get(
        `B2BAPIs/svc/digitalcertificateduplicatechecks/?_range=0-999&certType=${type}&certName=${name}`
      );
      return response.data[0].exists.code;
    } catch (error) {
      console.log(error);
      return 500;
    }
  };

  const temporalCertName = (type) => {
    if (ipAdress.length > 1) {
      let certName = ipAdress.split("/");
      certName = certName[2].split(":")[0];
      certName = `${certName}_${type}`;

      switch (type) {
        case "trusted":
          setNewExchangeCertificateName(certName);
          setEmptyFieldAlert(false);
          break;
        case "CA":
          setNewCaCertificateName(certName);
          setEmptyFieldAlert(false);
          break;
      }
    } else {
      setEmptyFieldAlert(true);
    }
  };

  const extractFile = (file, type) => {
    try {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        if (!!reader.result) {
          let text = reader.result;
          //remove break lines
          text = text.replace(/(\r\n|\n|\r)/gm, "");
          text = text
            .split("-----BEGIN CERTIFICATE-----")[1]
            .split("-----END CERTIFICATE-----")[0];
          switch (type) {
            case "trusted":
              setNewExchangeCertificateText(text);
              setEmptyFieldAlert(false);
              break;
            case "CA":
              setNewCaCertificateText(text);
              setEmptyFieldAlert(false);
              break;
          }
        }
      };
    } catch (error) {
      console.log(error);
    }
  };

  const createCertificate = async (type) => {
    if (type === "CA") {
      try {
        const response = await client.post(
          "B2BAPIs/svc/cadigitalcertificates/",
          setCaCertificateData(newCaCertificateText, newCaCertificateName)
        );
        //console.log(response.status)
        //console.log(response.data)
        return response.status;
      } catch (error) {
        return 500;
      }
    }
    if (type === "trusted") {
      try {
        const response = await client.post(
          "B2BAPIs/svc/trusteddigitalcertificates/",
          setTrustedCertificateData(
            newExchangeCertificateText,
            newExchangeCertificateName
          )
        );
        console.log(response.status);
        console.log(response.data);
        return response.status;
      } catch (error) {
        return 500;
      }
    }
    return 500;
  };

  const getCertificatesExpirationDate = async () => {
    try {
      const response = await client.get(
        `B2BAPIs/svc/as2tradingpartners/?_range=0-999&as2Identifier=${connection}`
      );

      if (response.data.length === 1) {
        const responseData = response.data[0];
        return {
          caExpDate: responseData.caCertificate[0].notAfterDate,
          exchangeExpDate: responseData.exchangeCertificate[0].notAfterDate,
        };
      }

      if (response.data.length > 1) {
        const responseData = response.data;

        responseData.map((partner) => {
          if (partner === connection) {
            return {
              caExpDate: partner.caCertificate[0].notAfterDate,
              exchangeExpDate: partner.exchangeCertificate[0].notAfterDate,
            };
          }
        });
      }

      return response.status;
    } catch (error) {
      return 500;
    }
  };

  const formatExpiration = async () => {
    try {
      const certsExpirationDates = await getCertificatesExpirationDate();

      const caCertExpDate = certsExpirationDates.caExpDate.split("/");
      const formattedCaExpDate =
        caCertExpDate[2] + caCertExpDate[0] + caCertExpDate[1];

      const trustedCertExpDate =
        certsExpirationDates.exchangeExpDate.split("/");
      const formattedTrustedExpDate =
        trustedCertExpDate[2] + trustedCertExpDate[0] + trustedCertExpDate[1];

      return {
        caExpirationDate: formattedCaExpDate,
        trustedExpirationDate: formattedTrustedExpDate,
      };
    } catch (error) {
      return 500;
    }
  };

  const changeCertName = async () => {
    try {
      const oldCertificateName = currentCaCertificateName.split("_");

      console.log(oldCertificateName);

      const suppName = oldCertificateName.slice(1, -1).join("_");
      const expDates = await formatExpiration();

      console.log(expDates);
      console.log(suppName);

      const newCaCertName = `CA_${suppName}_${expDates.caExpirationDate}`;
      const newTrustedCertName = `trusted_${suppName}_${expDates.trustedExpirationDate}`;

      const isCaCertDuplicate = await isCertificateDuplicated(
        "CA",
        newCaCertName
      );
      const isTrustedCertificateDuplicate = await isCertificateDuplicated(
        "trusted",
        newTrustedCertName
      );

      if (isCaCertDuplicate && caCertUpdate) {
        setCerAlert(true);
        await client.delete(
          `B2BAPIs/svc/cadigitalcertificates/${newCaCertificateName}`
        );
        return 500;
      } else if (isTrustedCertificateDuplicate && exchangeCertUpdate) {
        setCerAlert(true);
        await client.delete(
          `B2BAPIs/svc/trusteddigitalcertificates/${newExchangeCertificateName}`
        );
        return 500;
      }

      if (caCertUpdate) {
        await client.put(
          `B2BAPIs/svc/cadigitalcertificates/${newCaCertificateName}`,
          {
            certName: `${newCaCertName}`,
            verifyAuthChain: false,
            verifyValidity: false,
          }
        );
      }

      if (exchangeCertUpdate) {
        await client.put(
          `B2BAPIs/svc/trusteddigitalcertificates/${newExchangeCertificateName}`,
          {
            certName: `${newTrustedCertName}`,
            verifyAuthChain: false,
            verifyValidity: false,
          }
        );
      }

      return 200;
    } catch (error) {
      return 500;
    }
  };

  const sendMail = async () => {
    try {
      const response = await client.post(
        "scs/rcs/email",
        setUpdateMailData(userEmail, as2Id)
      );
      return response.status;
    } catch (error) {
      return 500;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verifyProcess = await submitUpdateAS2TradingPartner();
    setAs2TpVerification(verifyProcess);
  };

  const caCertificateUpdateHandler = () => {
    setCaCertUpdate((current) => !current);
  };

  const exchangeCertificateUpdateHandler = () => {
    setExchangeCertUpdate((current) => !current);
  };

  const updateTradingPartner = async () => {
    try {
      const response = await client.put(
        `B2BAPIs/svc/as2tradingpartners/${as2Id}`,
        setAs2PartnerData(
          connection,
          caCertUpdate ? newCaCertificateName : currentCaCertificateName,
          exchangeCertUpdate
            ? newExchangeCertificateName
            : currentExchangeCertificateName,
          ipAdress,
          profileName,
          adapterFlag,
          encryptionAlgo,
          signingAlgo
        )
      );

      return response.status;
    } catch (error) {
      return 500;
    }
  };

  const submitUpdateAS2TradingPartner = async () => {
    try {
      if (caCertUpdate) {
        if (newCaCertificateName === null) {
          setCerAlert(true);
          return {
            verification: false,
            msg: "No Certificate added.\n Please add one",
          };
        }
        const caCertificateCreation = await createCertificate("CA");

        if (caCertificateCreation === 500) {
          return {
            verification: false,
            msg: "Error in the Creation of the CA Certificate Creation.\n Wait a minute and try again",
          };
        }
      }

      if (exchangeCertUpdate) {
        if (newExchangeCertificateName === null) {
          setCerAlert(true);
          return {
            verification: false,
            msg: "No Certificate added.\n Please add one",
          };
        }
        const exchangeCertificateCreation = await createCertificate("trusted");

        if (exchangeCertificateCreation === 500) {
          return {
            verification: false,
            msg: "Error in the Creation of the Exchange Certificate Creation.\n Wait a minute and try again",
          };
        }
      }

      const as2Update = await updateTradingPartner();

      if (as2Update === 500 || as2Id.length === 0) {
        return {
          verification: false,
          msg: "Error in the Creation of the AS2 Trading Partner.\n Wait a minute and try again",
        };
      }

      if (caCertUpdate || exchangeCertUpdate) {
        const updatingCertsName = await changeCertName();
        if (updatingCertsName === 500) {
          return {
            verification: false,
            msg: "The Certificates already exists.\n Please try another ones",
          };
        }
      }

      const checkMailWasSended = await sendMail();

      if (checkMailWasSended === 500) {
        return {
          verification: true,
          msg: "Error while sending mail.\n But the process was correct",
        };
      }

      return {
        verification: true,
        msg: "AS2 Trading Relationship has been updated!!",
      };
    } catch (error) {
      return { verification: false, msg: "Error in the API" };
    }
  };

  const checkFields = () => {
    if (profileName.length > 0 && ipAdress.length > 0) setSuccessSubbmit(true);
    else setSuccessSubbmit(false);
  };

  return (
    <div>
      <Typography gutterBottom variant="h1" component="h1">
        <span className="cardcontain">
          AS2 Direct Connect | Update AS2 Relationship
        </span>
      </Typography>
      <Card className="p-4">
        {showAlert ? (
          <Alert
            severity="info"
            title="John Deere's AS2 IP Adress Range"
            onClose={displayInfoAlert}
          >
            <Link onClick={downnloadIpRanges}>
              View Partner Whitelist Firewall Rules
            </Link>
          </Alert>
        ) : null}

        {certAlert ? (
          <Alert severity="error" title="The Certificate already exists"></Alert>
        ) : null}

        {tradingPartnersList.length !== 0 && (
          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Partner's AS2 Identifier</h6>
              <Select
                id="trading-partner-list"
                defaultValue={tradingPartnersList.at(0).code}
                onChange={(e) => setConnection(e.target.value)}
              >
                {/* Create Options from the connections API call */}
                {tradingPartnersList.map((option,key) => (
                  <MenuItem
                    key={key}
                    value={option.code}
                  >{`${option.supp} - ${option.code}`}</MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={6} sm={3} mt={8}>
              <Button
                id="search_button"
                variant="primary"
                onClick={async () => {
                  const expDates = await getAs2ConnectionInfo();
                  setCertsExpDate(expDates);
                  setIsSearched(true);
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Partner's Identity/Profile Name</h6>
              <Input
                required
                placeholder="Name"
                id="profile-name"
                defaultValue={""}
                value={profileName}
                onChange={(e) => setProfileName(e.target.value.toUpperCase())}
              />
            </Grid>

            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Encryption Algorithm</h6>
              <Select
                value={encryptionAlgo}
                id="encryption-algorithm"
                onChange={(e) => setEncryptionAlgo(e.target.value)}
              >
                <MenuItem value="0">
                  Triple DES 168 CBC with PKCS5 padding
                </MenuItem>
                <MenuItem value="1">56-bit DES CBC with PKCS5 padding</MenuItem>
                <MenuItem value="2">
                  128-bit RC2 CBC with PKCS5 padding
                </MenuItem>
                <MenuItem value="4">40-bit RC2 CBC with PKCS5 padding</MenuItem>
                <MenuItem value="6">
                  128-bit AES CBC with PKCS5 padding
                </MenuItem>
                <MenuItem value="8">
                  256-bit AES CBC with PKCS5 padding
                </MenuItem>
              </Select>
            </Grid>
          </Grid>
          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Partner's End Point IP/URL</h6>
              <Input
                required
                placeholder="URL/IP Adress"
                id="ip-adress"
                value={ipAdress}
                onChange={(e) => setIpAdress(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Signing Algorithm</h6>
              <Select
                value={signingAlgo}
                id="signing-algorithm"
                onChange={(e) => setSigningAlgo(e.target.value)}
              >
                <MenuItem value="0">MD5</MenuItem>
                <MenuItem value="1">SHA1</MenuItem>
                <MenuItem value="2">SHA256</MenuItem>
                <MenuItem value="3">SHA384</MenuItem>
                <MenuItem value="4">SHA512</MenuItem>
                <MenuItem value="5">SHA-1</MenuItem>
                <MenuItem value="6">SHA-256</MenuItem>
                <MenuItem value="7">SHA-384</MenuItem>
                <MenuItem value="8">SHA-512</MenuItem>
              </Select>
            </Grid>
          </Grid>

          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel"> CA Certificate Date Expiration </h6>
              <Input
                readOnly
                value={certsExpDate.caExpDate}
                startAdornment={
                  <InputAdornment position="end">
                    <fuel-icon name={"calendar_month"} />
                  </InputAdornment>
                }
              />
            </Grid>
          </Grid>

          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Update CA Certificate?</h6>
              <Select defaultValue="0" onChange={caCertificateUpdateHandler}>
                <MenuItem value="0">NO</MenuItem>
                <MenuItem value="1">YES</MenuItem>
              </Select>
            </Grid>
          </Grid>

          {caCertUpdate ? (
            <Grid container alignItems="flex-start" spacing={4}>
              <Grid item xs={12} sm={6}>
                <p className="entryLabel">
                  CA Digital Certificate{" "}
                  <span className="textFormat">
                    (.cer or .der format required)
                  </span>
                </p>
                <FileInput
              id="ca-digital-certificate"
              name="ca-digital-certificate"
              ref={caCerRef}
              inputProps={{ accept: '.cer,.der' }}
              onChange={(event) => {
                      const files = event.target.files;
                      if (files && files.length > 0) {
                        validateCACert(files[0], "CA");
                      } else {
                        certName(null);
                      }
                    }}
              renderFileList={(fileList) => (
                <FileList>
                  {fileList?.map((file) => (
                    <FileListItem
                      key={file.name}
                      text={file.name}
                      validationState={
                        invalidCAFileType ? 'invalid' : 'valid'
                      }
                    />
                  ))}
                </FileList>
              )}
              renderValidations={() => (
                <>
                  <Typography component="div" variant="labelMedium">
                    File Format
                  </Typography>
                  <FileValidationList>
                    <FileValidationListItem
                      text="File Type (.cer, .der)"
                      state={invalidCAFileType ? 'invalid' : 'valid'}
                    />
                  </FileValidationList>
                </>
              )}
            />
              </Grid>
            </Grid>
          ) : null}

          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">
                {" "}
                Signing Certificate Date Expiration{" "}
              </h6>
              <Input
                readOnly
                value={certsExpDate.trustedExpDate}
                startAdornment={
                  <InputAdornment position="end">
                    <fuel-icon name={"calendar_month"} />
                  </InputAdornment>
                }
              />
            </Grid>
          </Grid>

          <Grid container alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <h6 className="entryLabel">Update Signing Certificate?</h6>
              <Select
                defaultValue="0"
                onChange={exchangeCertificateUpdateHandler}
              >
                <MenuItem value="0">NO</MenuItem>
                <MenuItem value="1">YES</MenuItem>
              </Select>
            </Grid>
          </Grid>

          {exchangeCertUpdate ? (
            <Grid container alignItems="flex-start" spacing={4}>
              <Grid item xs={12} sm={6}>
                <p className="entryLabel">
                  Exchange/Signing Certificate{" "}
                  <span className="textFormat">
                    (.cer or .der format required)
                  </span>
                </p>
              <FileInput
              id="ex-digital-certificate"
              name="ex-digital-certificate"
              ref={exSignCerRef}
              inputProps={{ accept: '.cer,.der' }}
              onChange={(event) => {
                      const files = event.target.files;
                      if (files && files.length > 0) {
                        validateExSignCert(files[0], "trusted");
                      } else {
                        certName(null);
                      }
                    }}
              
              renderFileList={(fileList) => (
                  <FileList>
                    {fileList?.map((file) => (
                      <FileListItem
                        key={file.name}
                        text={file.name}
                        validationState={
                          invalidExSignFileType ? 'invalid' : 'valid'
                        }
                      />
                    ))}
                  </FileList>
                )}
              renderValidations={() => (
                <>
                  <Typography component="div" variant="labelMedium">
                    File Format
                  </Typography>
                  <FileValidationList>
                    <FileValidationListItem
                      text="File Type (.cer, .der)"
                      state={invalidExSignFileType ? 'invalid' : 'valid'}
                    />
                  </FileValidationList>
                </>
              )}
            />
              </Grid>
            </Grid>
          ) : null}

          <Grid container mt={5} alignItems="flex-start" spacing={4}>
            <Grid item xs={6} sm={3}>
              <SubmitAs2
                controlSubmit={successSubmit}
                as2Verification={as2TpVerification.verification}
                message={as2TpVerification.msg}
                update={true}
              />
            </Grid>

            <Grid item xs={12} sm={"auto"}>
              <Typography size="md" fontWeight="bold" component="p">
                John Deere's AS2 IP Adress Range
                <IconButton onClick={displayInfoAlert}>
                  <fuel-icon name={"info"} />
                </IconButton>
              </Typography>

              <Typography
                size="md"
                fontWeight="regular"
                component={"p"}
                className="textFormat"
              >
                Partner Whitelist Firewall Rules
                <IconButton aria-label="download" onClick={downnloadIpRanges}>
                  <fuel-icon name={"download"} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Card>
    </div>
  );
};

export default UpdateAs2RelationShip;
